import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {Router} from "@angular/router";
import moment from "moment/moment";
import swal from "sweetalert2";
import {DataSnapshotScenarioService} from "../utils/data-services/data-snapshot-scenario.service";
import {MatPaginator} from "@angular/material/paginator";

@Component({
  selector: 'app-gestion-snapshot-scenario',
  templateUrl: './gestion-snapshot-scenario.component.html',
  styleUrls: ['./gestion-snapshot-scenario.component.scss']
})
export class GestionSnapshotScenarioComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  dataSource = new MatTableDataSource();

  constructor( private dataService: DataSnapshotScenarioService, private route: Router ) {}
  displayedColumns: string[] = ['brand', 'label', 'operations', 'is_courtesy_car', 'is_wating', 'is_active', 'modifier'];
  search: any;

  ngOnInit() {
    this.dataService.getSnapshotScenario().subscribe(snapshotScenario => {
      this.dataSource.data = snapshotScenario;
      this.search = localStorage.getItem('scenarioFilter') != null ? localStorage.getItem('scenarioFilter') : '';
      this.dataSource.filter = this.search.trim().toLowerCase();
      this.paginator.pageIndex = localStorage.getItem('pageIndexScenario') != null ? parseInt(localStorage.getItem('pageIndexScenario')) : null;
      this.paginator.pageSize = localStorage.getItem('pageSizeScenario') != null ? parseInt(localStorage.getItem('pageSizeScenario')) : null;
      this.dataSource.paginator = this.paginator;
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    localStorage.setItem('scenarioFilter', filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  frenchDate(date: any) {
    return moment(date).format('L');
  }
  onClickMessage(message) {
    swal.fire({
      title: 'Message',
      text: message,
      confirmButtonText: 'Ok'
    });
  }
  SelectChangeHandlerCreer() {
    this.route.navigate(['../create-snapshot-scenario']);
  }
  SelectChangeHandlerModifier(snapshotScenarioId) {
    this.route.navigate(['../update-snapshot-scenario/' + snapshotScenarioId]);
  }
  getPageSizeOptions(): number[] {
    if (this.dataSource && this.dataSource.data.length > 100 && this.dataSource.paginator) {
      return [20, 50, 100,  this.dataSource.paginator.length];
    } else {
      return [20, 50, 100];
    }
  }
  displayPaginatorAllOption() {
    const matOptions = document.getElementsByClassName('mat-option-text');
    // @ts-ignore
    for (const options of matOptions) {
      options.innerHTML = options.innerHTML == this.dataSource.data.length ? 'Tous' : options.innerHTML;
    }
  }
  pageChange() {
    localStorage.setItem('pageIndexScenario', String(this.paginator.pageIndex));
    localStorage.setItem('pageSizeScenario', String(this.paginator.pageSize));
  }
}
